export default __webpack_public_path__ + "assets/img/keyboard.4989bed57be514e4374875d77e3199b7.svg";